<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <div class="form-group">
      <label class="black title-bold" for="nome">{{ $t('enter_cpf') }}</label>
      <div class="error mt-n2" v-if="$v.localCpf.$error">
        <span class="error " v-if="!$v.localCpf.required">{{ $t('cpf') + $t('is_required') }}</span>
        <span class="error " v-else-if="!$v.localCpf.validCpf">{{ $t('cpf') + $t('invalid') }}</span>
      </div>
      <input
        type="text"
        class="form-control"
        id="cpf"
        :placeholder="$t('type_here')"
        v-model="localCpf"
        @keydown.enter="goToNextStep"
        v-mask="'###.###.###-##'"
        @blur="$v.localCpf.$touch()"
      />
    </div>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance') }}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";
import { mask } from "vue-the-mask";
import { Survey } from "../../services/Survey.js";
const surveyService = new Survey();

const validCpf = (strCPF) => {
  if (!strCPF || !strCPF.length) {
    return false
  }
  let Soma
  let Resto
  Soma = 0
  strCPF = strCPF.replace(/[^\d]/g, '')
  if (strCPF === '00000000000' || strCPF === '11111111111' || strCPF === '22222222222' || strCPF === '33333333333' || strCPF === '44444444444' || strCPF === '55555555555' || strCPF === '66666666666' || strCPF === '77777777777' || strCPF === '88888888888' || strCPF === '99999999999') {
    return false
  }
  let i
  for (i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
  }
  Resto = (Soma * 10) % 11

  if (Resto === 10 || Resto === 11) {
    Resto = 0
  }
  if (Resto !== parseInt(strCPF.substring(9, 10))) {
    return false
  }

  Soma = 0
  for (i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
  }
  Resto = (Soma * 10) % 11

  if (Resto === 10 || Resto === 11) {
    Resto = 0
  }
  if (Resto !== parseInt(strCPF.substring(10, 11))) {
    return false
  }
  return true
}

export default {
  name: "Register-Cpf-Text",
  components: {Navigation},
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      localCpf: ''
    }
  },
  watch: {
    localCpf () {
      this.profile.Numbers[0].Number = this.localCpf
    }
  },
  directives: {
    mask
  },
  validations: {
    localCpf: {
      required,
      validCpf
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
    template() {
      return this.$store.state.template
    }
  },
  mounted() {
    this.localCpf = this.profile.Numbers[0].Number
    if (this.activeStepIndex !== 0) this.focusOn('cpf')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      if (!this.$v.$invalid) {
        if (this.template.home.useEmail) {
          this.checkStarted()
        } else {
          this.$emit('next')
        }
      }
    },
    checkStarted() {
      this.processingApi = true;
      surveyService.CheckStart(
        this.template.survey.id,
        this.template.survey.prj,
        '',
        this.localCpf,
        1
      ).then(
        (ret) => {
          if (ret.identity) {
            this.$store.commit('SET_RegistrationCode', this.localCpf)
            this.$store.commit("SET_TermsAccepted", true)
            this.processingApi = false
            this.$emit('start-survey')
          } else {
            this.processingApi = false
            this.$emit('next')
          }
        },
        (err) => {
          this.$vs.notify({
            color: "RGBA(255,0,0)",
            title: this.$t('problem_ocurred'),
            text: this.$t('error_verifying_survey_start') + err,
            time: 5000
          });
          this.processingApi = false;
        }
      );
    }
  }
}
</script>
